import { FileCheck2, Route, LifeBuoy, Images, RefreshCw, ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import copy from "@/content/homepage-copy.json";

// Sekcja wartości pakietu (zastępuje mikrokafle „Co otrzymujesz").
const ICON = { FileCheck2, Route, LifeBuoy, Images, RefreshCw };

const Badge = ({ label }) => {
  const strong = label === "AKTUALIZACJE GRATIS";
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 font-display text-[11px] font-bold tracking-[0.06em] ${
        strong ? "bg-brand-accent text-brand-on" : "border border-brand-accent/40 bg-brand-accent/5 text-brand-accent"
      }`}
    >
      {label}
    </span>
  );
};

const ValueCard = ({ item, span }) => {
  const Icon = ICON[item.icon] || FileCheck2;
  return (
    <div
      className={`hover-glow relative flex min-h-[190px] flex-col overflow-hidden rounded-[14px] border border-brand-line bg-brand-surface p-6 sm:p-7 ${span}`}
      data-testid={`value-card-${item.id}`}
    >
      {/* subtelny zielony akcent u góry */}
      <span className="pointer-events-none absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-brand-accent/70 via-brand-accent/20 to-transparent" aria-hidden="true" />
      <div className="mb-5 flex items-center justify-between gap-3">
        <span className="font-display text-lg font-bold text-brand-line">{item.number}</span>
        <Badge label={item.badge} />
      </div>
      <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-field border border-brand-line text-brand-accent">
        <Icon size={24} strokeWidth={1.75} aria-hidden="true" />
      </span>
      <h3 className="font-display text-[20px] font-semibold leading-snug text-brand-text">{item.title}</h3>
      <p className="mt-2 text-[16px] leading-[1.6] text-brand-sec">{item.text}</p>
      {/* value = null → nie pokazujemy kwoty */}
      {item.value != null && (
        <p className="mt-3 font-display text-sm font-semibold text-brand-accent">{item.value}</p>
      )}
    </div>
  );
};

export const IncludedSection = () => {
  const inc = copy.included;
  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-[88px] md:pb-[120px]" data-testid="included-section">
      <SectionHeading chapter={inc.eyebrow} title={inc.title} lead={inc.lead} size="lg" />

      {inc.benefits && (
        <Reveal delay={0.08}>
          <div className="mt-8 flex flex-wrap justify-center gap-3" data-testid="included-benefits">
            {inc.benefits.map((b) => (
              <span key={b} className="inline-flex items-center gap-2 rounded-full border border-brand-accent/30 bg-brand-accent/5 px-4 py-2 text-sm font-medium text-brand-text">
                <Check size={16} strokeWidth={2.5} className="text-brand-accent" aria-hidden="true" />
                {b}
              </span>
            ))}
          </div>
        </Reveal>
      )}

      {/* 3 + 2 grid (desktop), stack na mobile */}
      <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-6">
        {inc.items.map((item, i) => (
          <Reveal key={item.id} delay={(i % 3) * 0.06} className={i < 3 ? "lg:col-span-2" : "lg:col-span-3"}>
            <ValueCard item={item} span="h-full" />
          </Reveal>
        ))}
      </div>

      {/* pasek podsumowania + CTA */}
      <Reveal delay={0.1}>
        <div
          className="glow-strong mt-6 flex flex-col items-stretch gap-4 rounded-panel border border-brand-accent/30 bg-brand-elevated p-6 sm:flex-row sm:items-center sm:justify-between"
          data-testid="value-summary"
        >
          <p className="max-w-2xl text-[16px] leading-relaxed text-brand-sec">{inc.summary}</p>
          <Link
            to="/rejestracja"
            data-testid="value-cta"
            className="cta-glow inline-flex shrink-0 items-center justify-center gap-2 rounded-button bg-brand-accent px-7 py-4 text-base font-semibold text-brand-on transition-transform duration-200 hover:-translate-y-0.5"
          >
            {inc.cta}
            <ArrowRight size={18} strokeWidth={2} aria-hidden="true" />
          </Link>
        </div>
      </Reveal>
    </section>
  );
};
